import { render, staticRenderFns } from "./HeaderWidgetBalance.vue?vue&type=template&id=3b4704fc&"
import script from "./HeaderWidgetBalance.vue?vue&type=script&lang=js&"
export * from "./HeaderWidgetBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports